import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetail } from "@/components/site/ServiceDetail";
import militaryAssetUrl from "@/assets/svc-military.webp";
const militaryAsset = { url: militaryAssetUrl };

export const Route = createFileRoute("/services/military")({
  head: () => ({
    meta: [
      { title: "Military March-Out Cleaning in Tidworth & Bulford | IZHUB" },
      { name: "description", content: "Specialist military march-out cleaning to MOD inspection standard across Tidworth, Bulford, Larkhill and Salisbury Plain. Full deposit and charges avoided. Instant quote online." },
      { property: "og:title", content: "Military March-Out Cleaning | IZHUB Cleaning Services" },
      { property: "og:description", content: "SFA march-out cleans to MOD inspection standard for serving personnel and military families across Tidworth, Bulford and Larkhill." },
      { property: "og:url", content: "https://izhubcleaning.uk/services/military" },
    ],
    links: [{ rel: "canonical", href: "https://izhubcleaning.uk/services/military" }],
  }),
  component: MilitaryPage,
});

function MilitaryPage() {
  return (
    <ServiceDetail
      data={{
        title: "Military march-out cleaning",
        heroTitle: <>March out first time, <span className="rainbow-text">without the stress</span>.</>,
        intro: "Specialist march-out cleaning to the MOD inspection standard for Service Family Accommodation across Tidworth, Bulford, Larkhill and the wider Salisbury Plain garrison area.",
        image: militaryAsset.url,
        imageAlt: "A military family home cleaned to march-out inspection standard",
        forWho: "Serving personnel and military families moving out of SFA across Tidworth, Bulford and Larkhill.",
        quoteService: "military",
        includes: [
          "Cleaned to march-out inspection standard",
          "Oven, hob, extractor and fridge/freezer inside and out",
          "Cupboard interiors, skirting boards and door frames",
          "Light fittings, switches, radiators and vents",
          "Bathroom descale, tiles, grout and sanitary fixtures",
          "Internal windows, sills and tracks throughout",
        ],
        paragraphs: [
          "March-out inspections are notoriously strict, and failing one can mean charges against your quarter bill on top of everything else you're dealing with during a move. Our military march-out cleans follow the MOD inspection standard for Service Family Accommodation, covering exactly the areas housing inspectors check: ovens, limescale, cupboard interiors, skirting and every detail in between.",
          "We're a local team based on the doorstep of the Salisbury Plain garrison, so we know the SFA housing stock, the typical inspection pain points, and the tight timelines around postings. We work around your moving schedule, including short-notice bookings, so the clean is ready before your handover appointment.",
          "If an inspector does flag anything, tell us within 48 hours and we'll come back and put it right at no extra cost. That's our march-out guarantee. Book your clean online for an instant fixed estimate, or send your move-out date on WhatsApp and we'll get you scheduled.",
        ],
      }}
    />
  );
}
